
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class CardHead extends Vue {
  @Prop({ default: "Name Here" }) readonly name!: string;
  @Prop(Boolean) readonly active!: boolean;
  @Prop(Boolean) readonly avatar!: boolean;
  @Prop(Boolean) readonly nameonly!: boolean;
}
